module.exports = __webpack_public_path__ + "media/images/photos/7-ae200a25a423beaa73eeb7211600a446.jpg";